import { render, staticRenderFns } from "./GlobalB.vue?vue&type=template&id=52d02fe1&scoped=true"
import script from "./GlobalB.vue?vue&type=script&lang=js"
export * from "./GlobalB.vue?vue&type=script&lang=js"
import style0 from "./GlobalB.vue?vue&type=style&index=0&id=52d02fe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d02fe1",
  null
  
)

export default component.exports